import { render, staticRenderFns } from "./ninth.vue?vue&type=template&id=1fcb4140&scoped=true"
import script from "./ninth.vue?vue&type=script&lang=js"
export * from "./ninth.vue?vue&type=script&lang=js"
import style0 from "./ninth.vue?vue&type=style&index=0&id=1fcb4140&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcb4140",
  null
  
)

export default component.exports